import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

/* ═══════════════════════════════════════
   TabNav (v2) — 공통 서브페이지 탭 내비게이션
   100% 인라인 스타일 — 어떤 글로벌 CSS도 못 이김
   ═══════════════════════════════════════ */

const navStyle = {
  background: '#ffffff',
  borderBottom: '1px solid #e5e7eb',
  position: 'sticky',
  top: 0,
  zIndex: 20,
  width: '100%',
  boxSizing: 'border-box',
};

const innerStyle = {
  maxWidth: '1200px',
  margin: '0 auto',
  padding: '0 32px',
  display: 'flex',
  gap: 0,
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
};

function getTabStyle(isActive) {
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 640;
  return {
    display: 'inline-flex',
    alignItems: 'center',
    gap: isMobile ? '4px' : '8px',
    padding: isMobile ? '12px 14px' : '16px 24px',
    fontSize: isMobile ? '13px' : '15px',
    fontWeight: isActive ? '700' : '600',
    color: isActive ? '#0e7490' : '#374151',
    WebkitTextFillColor: isActive ? '#0e7490' : '#374151',
    background: isActive ? '#ecfeff' : 'transparent',
    textDecoration: 'none',
    borderBottom: isActive ? '3px solid #0891b2' : '3px solid transparent',
    transition: 'all 0.2s ease',
    whiteSpace: 'nowrap',
    flexShrink: 0,
  };
}

export default function TabNav({ tabs, activeType }) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 640 : false
  );

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 640);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const mobileInner = isMobile
    ? { ...innerStyle, padding: '0 12px' }
    : innerStyle;

  return (
    <nav style={navStyle}>
      <div style={mobileInner}>
        {tabs.map((tab) => (
          <Link
            key={tab.type || tab.path}
            to={tab.path}
            style={getTabStyle(activeType === tab.type)}
          >
            {tab.icon && <span>{tab.icon}</span>}
            <span>{tab.label}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
}
